import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { TenantThemeProvider } from './theme/TenantThemeProvider';
import { AuthProvider } from './auth/AuthProvider';
import { ToastProvider } from './components/common/ToastProvider';
import { App } from './App';
import { BreadcrumbNameProvider } from './components/BreadcrumbNameProvider';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, staleTime: 15_000, refetchOnWindowFocus: false },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* AuthProvider now wraps the theme, because the theme is per TENANT: it
          cannot be resolved before we know who is signed in and where. Toasts stay
          inside the theme so they are themed, and outside the router so one
          survives a navigation triggered by the action that raised it. */}
      <AuthProvider>
        <TenantThemeProvider>
          <ToastProvider>
            <BrowserRouter>
              {/* Inside the router, because a published name belongs to a route
                  and must be withdrawn when that route unmounts. */}
              <BreadcrumbNameProvider>
                <App />
              </BreadcrumbNameProvider>
            </BrowserRouter>
          </ToastProvider>
        </TenantThemeProvider>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
